import React, { useState } from 'react';
import { Phone as PhoneIcon, MapPin, StarIcon, XIcon, FacebookIcon, InstagramIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
function PolicyModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-128" data-mp="3uf0opddwyguv">
      <div className="bg-white rounded-sm max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-129" data-mp="38z9csmx113f">
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-130" data-mp="3le2icog05x94">
          <h2 className="text-xl font-serif text-brand-brown" data-id="element-131" data-mp="3qbvmlbxqwh6r">{title}</h2>
          <button onClick={onClose} className="p-1 text-gray-400 hover:text-brand-brown transition-colors" aria-label="Cerrar" data-id="element-132" data-mp="29yxbr9cr3ek8">
            <XIcon className="w-5 h-5" data-id="element-133" data-mp="2ezutxlxrg8lq" />
          </button>
        </div>
        <div className="p-6 text-sm text-gray-600 space-y-4 leading-relaxed" data-id="element-134" data-mp="3lalh7iesgbvj">
          {children}
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const {
    t
  } = useLanguage();
  return <>
      <footer className="bg-brand-dark text-white py-12 border-t border-brand-gold/15" data-id="element-135" data-mp="3q726ifxq4wa7">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136" data-mp="81pfbipu2x9d">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-137" data-mp="34gvldp1el60">
            {/* Logo Image */}
            <div className="flex-shrink-0 flex flex-col items-center gap-4" data-id="element-138" data-mp="hrs8biwygb7p">
              <img src="https://cdn.magicpatterns.com/uploads/d5PCZLxog3stu5Kmdcos9m/tairu_new_1.png" alt="Tairu Aesthetics" className="h-20 w-auto object-contain mix-blend-lighten" data-id="element-139" data-mp="ct76jf221jh5" />
              {/* Social Icons */}
              <div className="flex items-center gap-4" data-id="element-140" data-mp="msy27k2cq4it">
                <a href="https://www.facebook.com/katherine.ospino.95063" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-brand-gold-light transition-colors" aria-label="Facebook" data-id="element-141" data-mp="tv4m9yxi8y3f">
                  <FacebookIcon className="w-5 h-5" data-id="element-142" data-mp="13tkclzopk3bv" />
                </a>
                <a href="https://www.instagram.com/tairu.aesthetics/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-brand-gold-light transition-colors" aria-label="Instagram" data-id="element-143" data-mp="13r7pl843f2ry">
                  <InstagramIcon className="w-5 h-5" data-id="element-144" data-mp="1cnyu88wpnpy5" />
                </a>
              </div>
              {/* Google Reviews Button */}
              <a href="https://share.google/aeNeaqJ9AadTchr2e" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-xs font-medium text-brand-gold-light hover:text-brand-gold transition-colors border border-brand-gold/30 px-3 py-1.5 rounded-sm" data-id="element-145" data-mp="1mjiluj48s2h3">
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-146" data-mp="3t9yi5pt9oi2n" />
                {t('footer.reviews')}
              </a>

              {/* Accepted Payment Methods */}
              <div className="flex flex-col items-center gap-2 pt-2" data-id="element-147" data-mp="2ah84uvf2t8uz">
                <p className="text-[10px] text-gray-500 uppercase tracking-widest" data-id="element-148" data-mp="25nlrt25032yn">
                  {t('footer.payments')}
                </p>
                <div className="flex items-center gap-3" data-id="element-149" data-mp="1wnp87exgwuag">
                  {/* Visa */}
                  <svg viewBox="0 0 48 32" className="h-7 w-auto" aria-label="Visa" data-id="element-150" data-mp="1wlvz7szdtxza">
                    <rect width="48" height="32" rx="4" fill="#1A1F71" data-id="element-151" data-mp="2td6jqaj4tak2" />
                    <text x="24" y="20" textAnchor="middle" fill="#FFFFFF" fontSize="14" fontWeight="bold" fontFamily="Arial, sans-serif" fontStyle="italic" data-id="element-152" data-mp="2pdpgzov3aril">
                      VISA
                    </text>
                  </svg>
                  {/* Mastercard */}
                  <svg viewBox="0 0 48 32" className="h-7 w-auto" aria-label="Mastercard" data-id="element-153" data-mp="18ynvvglikyzw">
                    <rect width="48" height="32" rx="4" fill="#2D2D2D" data-id="element-154" data-mp="13zbc54pxw81j" />
                    <circle cx="19" cy="16" r="9" fill="#EB001B" data-id="element-155" data-mp="141e9yaxc35gt" />
                    <circle cx="29" cy="16" r="9" fill="#F79E1B" data-id="element-156" data-mp="2ru6d7qgvz7i0" />
                    <path d="M24 9.17a9 9 0 0 1 0 13.66 9 9 0 0 1 0-13.66z" fill="#FF5F00" data-id="element-157" data-mp="2wmzeu5h25zpv" />
                  </svg>
                  {/* American Express */}
                  <svg viewBox="0 0 48 32" className="h-7 w-auto" aria-label="American Express" data-id="element-158" data-mp="2isyifidkwoso">
                    <rect width="48" height="32" rx="4" fill="#006FCF" data-id="element-159" data-mp="2ns1nv3xh0x16" />
                    <text x="24" y="14" textAnchor="middle" fill="#FFFFFF" fontSize="7" fontWeight="bold" fontFamily="Arial, sans-serif" data-id="element-160" data-mp="3bk8d7j4s43r3">
                      AMERICAN
                    </text>
                    <text x="24" y="22" textAnchor="middle" fill="#FFFFFF" fontSize="7" fontWeight="bold" fontFamily="Arial, sans-serif" data-id="element-161" data-mp="31krbtdwk8c0x">
                      EXPRESS
                    </text>
                  </svg>
                  {/* Discover */}
                  <svg viewBox="0 0 48 32" className="h-7 w-auto" aria-label="Discover" data-id="element-162" data-mp="1v574kace43pa">
                    <rect width="48" height="32" rx="4" fill="#FFFFFF" stroke="#E5E7EB" strokeWidth="0.5" data-id="element-163" data-mp="1nlxueew280z6" />
                    <text x="24" y="14" textAnchor="middle" fill="#231F20" fontSize="6.5" fontWeight="bold" fontFamily="Arial, sans-serif" data-id="element-164" data-mp="1in4qne6kroc7">
                      DISCOVER
                    </text>
                    <circle cx="24" cy="22" r="5" fill="#F47216" data-id="element-165" data-mp="1rnstdcqiq29s" />
                  </svg>
                </div>
              </div>
            </div>

            {/* Info */}
            <div className="text-center md:text-right text-sm text-gray-400 space-y-2" data-id="element-166" data-mp="13vvvkpjwlaro">
              <p className="font-serif text-brand-gold-light text-lg mb-2" data-id="element-167" data-mp="zy7uf4rmalrc">
                {t('footer.tagline')}
              </p>
              <p className="flex items-center justify-center gap-2" data-id="element-168" data-mp="18x1lkfm6ijxi">
                Phenix Salon Suite (#114), 100 Broadway, Elmwood Park, NJ 07407
              </p>
              <p className="flex items-center justify-center md:justify-end gap-2" data-id="element-169" data-mp="l5nyao2vxeje">
                <PhoneIcon className="w-4 h-4 text-brand-gold-light" data-id="element-170" data-mp="g7uqjqlxoch0" />
                <a href="tel:5513328938" className="hover:text-brand-gold-light transition-colors" data-id="element-171" data-mp="2gbf3xcyejkqj">
                  (551) 332-8938
                </a>
              </p>

              {/* Privacy & Terms */}
              <div className="flex items-center justify-center md:justify-end gap-4 pt-3" data-id="element-172" data-mp="2q1hxbe9fr0pe">
                <button onClick={() => setPrivacyOpen(true)} className="text-xs text-gray-500 hover:text-brand-gold-light transition-colors underline underline-offset-2" data-id="element-173" data-mp="2uzt6rnvtj973">
                  {t('footer.privacy')}
                </button>
                <span className="text-gray-600 text-xs" data-id="element-174" data-mp="22b4bw6lcw03s">|</span>
                <button onClick={() => setTermsOpen(true)} className="text-xs text-gray-500 hover:text-brand-gold-light transition-colors underline underline-offset-2" data-id="element-175" data-mp="279pbc3ssafr6">
                  {t('footer.terms')}
                </button>
              </div>

              <p className="pt-4 text-xs opacity-60" data-id="element-176" data-mp="3irgp3hf0lbxr">
                © {new Date().getFullYear()} TAIRU AESTHETICS.{' '}
                {t('footer.rights')}
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <PolicyModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-177" data-mp="172aidr4ymy3v">
        <p data-id="element-178" data-mp="1297pzmbx5up9">
          <strong data-id="element-179" data-mp="128piftjt3u21">Última actualización:</strong> Mayo 2026
        </p>
        <p data-id="element-180" data-mp="xbfwwozjg2jh">
          En Tairu Aesthetics, respetamos su privacidad y nos comprometemos a
          proteger su información personal. Esta política describe cómo
          recopilamos, usamos y protegemos sus datos.
        </p>
        <p data-id="element-181" data-mp="ng4g814kkl93">
          <strong data-id="element-182" data-mp="jc6hvsn2jeh3">Información que recopilamos:</strong>
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-183" data-mp="jcg89hc0znnb">
          <li data-id="element-184" data-mp="edmsfi99nkjz">
            Nombre, número de teléfono y correo electrónico proporcionados al
            agendar citas.
          </li>
          <li data-id="element-185" data-mp="2dow7vzabg3j7">
            Información sobre su historial de tratamientos y condiciones de la
            piel.
          </li>
          <li data-id="element-186" data-mp="28p1hrxyd7hz7">
            Datos de navegación recopilados automáticamente (cookies, dirección
            IP).
          </li>
        </ul>
        <p data-id="element-187" data-mp="1mld3kwgxkuna">
          <strong data-id="element-188" data-mp="1mjtnb5v9yjli">Uso de la información:</strong>
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-189" data-mp="17vyuzql6ih8y">
          <li data-id="element-190" data-mp="17v5xlg84143h">Programar y gestionar sus citas.</li>
          <li data-id="element-191" data-mp="1cv201b15sngx">Personalizar su experiencia de tratamiento.</li>
          <li data-id="element-192" data-mp="1cth2dcjjsoeu">
            Enviar recordatorios y comunicaciones relacionadas con sus
            servicios.
          </li>
        </ul>
        <p data-id="element-193" data-mp="12ww0v16qlvfr">
          <strong data-id="element-194" data-mp="12xdstlmd9nhv">Protección de datos:</strong> Implementamos medidas de
          seguridad técnicas y organizativas para proteger su información
          personal contra acceso no autorizado, pérdida o alteración.
        </p>
        <p data-id="element-195" data-mp="tx908hlu0tnr">
          <strong data-id="element-196" data-mp="twppplyih7jr">Sus derechos:</strong> Usted tiene derecho a acceder, corregir
          o eliminar su información personal en cualquier momento contactándonos
          al (551) 332-8938.
        </p>
        <p data-id="element-197" data-mp="2o9p1f3zrthlr">
          No vendemos ni compartimos su información personal con terceros para
          fines de marketing.
        </p>
      </PolicyModal>

      {/* Terms Modal */}
      <PolicyModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-198" data-mp="7otowsn3sqn4">
        <p data-id="element-199" data-mp="mdghhw1qrewa">
          <strong data-id="element-200" data-mp="me8086a8pi55">Última actualización:</strong> Mayo 2026
        </p>
        <p data-id="element-201" data-mp="hlolh5ztggyr">
          Al utilizar los servicios de Tairu Aesthetics, usted acepta los
          siguientes términos y condiciones:
        </p>
        <p data-id="element-202" data-mp="vffywpgo4kzr">
          <strong data-id="element-203" data-mp="vf68x1vmidu2">Citas y Cancelaciones:</strong>
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-204" data-mp="qdgv5eh0nm2a">
          <li data-id="element-205" data-mp="15biwrj4hlxgw">
            Las citas deben ser agendadas con anticipación llamando al (551)
            332-8938.
          </li>
          <li data-id="element-206" data-mp="10c6e7aknfck4">
            Solicitamos un aviso de al menos 24 horas para cancelaciones o
            reprogramaciones.
          </li>
          <li data-id="element-207" data-mp="3735vk6umewnx">
            Las cancelaciones tardías o ausencias pueden estar sujetas a un
            cargo.
          </li>
        </ul>
        <p data-id="element-208" data-mp="ityur21q59q3">
          <strong data-id="element-209" data-mp="iurtpgufyuxo">Servicios:</strong>
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-210" data-mp="ivjquw3ot0q2">
          <li data-id="element-211" data-mp="dum7whaus2ni">
            Todos los tratamientos comienzan con una evaluación personalizada de
            la piel.
          </li>
          <li data-id="element-212" data-mp="8wu8z3bsjg9t">
            Los resultados pueden variar según el tipo de piel y la condición
            individual.
          </li>
          <li data-id="element-213" data-mp="3zc5hsgjlt97">
            Kate se reserva el derecho de recomendar o declinar tratamientos
            basándose en su evaluación profesional.
          </li>
        </ul>
        <p data-id="element-214" data-mp="wm58yilbh6mw">
          <strong data-id="element-215" data-mp="wmeyy66d3dsl">Responsabilidad:</strong> Tairu Aesthetics no se hace
          responsable por reacciones adversas que resulten de la omisión de
          información médica relevante por parte del cliente.
        </p>
        <p data-id="element-216" data-mp="mtzgl7r5kn76">
          <strong data-id="element-217" data-mp="1kaxz1yf9ck9l">Propiedad intelectual:</strong> Todo el contenido de este
          sitio web, incluyendo imágenes, textos y diseño, es propiedad de Tairu
          Aesthetics y está protegido por las leyes de derechos de autor.
        </p>
        <p data-id="element-218" data-mp="1nugjzulpmexa">
          Para preguntas sobre estos términos, contáctenos al (551) 332-8938.
        </p>
      </PolicyModal>
    </>;
}